import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { MotoresTransmissaoService } from 'src/app/services/motores-transmissao/motores-transmissao.service';

@Component({
  selector: 'app-motores-transmissao',
  templateUrl: './motores-transmissao.component.html',
  styleUrls: ['./motores-transmissao.component.css']
})
export class MotoresTransmissaoComponent implements OnInit, OnDestroy {
  engineAndTranmissionDocks: DocksModel[] = []
  dateInterval: any
  updateInterval: any

  timeTableIsVisible: boolean = false;

  private readonly DEFAULT_COLOR = '#FFF'
  private readonly ACTIVE_COLOR = '#3CB371'
  private readonly INACTIVE_COLOR = '#FF2340'

  Date = Date.now();

  constructor(private readonly motoresTransmissaoService: MotoresTransmissaoService) { }

  ngOnInit() {
    this.updateData();

    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.motoresTransmissaoService.getEngineAndTransmissionDocksDataView().pipe
      (take(1),
        catchError(() => {
          return of([])
        })
      ).subscribe(
        (response) => {
          this.engineAndTranmissionDocks = response.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }

  ngOnDestroy() {
    clearInterval(this.dateInterval);
    clearInterval(this.updateInterval);
  }

  //* ---------------------- BOTÕES DOCAS ---------------------- *//

  public statusDocks(docks: number): string {

    const dock = this.engineAndTranmissionDocks.find((t) => t.id == docks);
    if (this.isDockValidAndActive(dock)) {
      switch (dock?.truck) {
        case 0:
          return this.DEFAULT_COLOR
        case 1:
          return this.ACTIVE_COLOR
        default:
          return "Valor no campo 'Truck' inválido"
      }
    } return this.INACTIVE_COLOR
  }

  private isDockValidAndActive(dock: any): boolean {
    return dock && dock.truck !== undefined && dock.status && dock.active == 1
  }

  // time-table control

  openPlanning() {
    this.timeTableIsVisible = !this.timeTableIsVisible
  }


}

